
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utrzymanie-aplikacji",
      function () {
        return require("private-next-pages/utrzymanie-aplikacji.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/utrzymanie-aplikacji"])
      });
    }
  